// extracted by mini-css-extract-plugin
module.exports = {"title":"edit_tracking__title___3fLHu _type__vx_text-2___Qizsf","save-button":"edit_tracking__save-button___SY07p","checkbox-wrapper":"edit_tracking__checkbox-wrapper___2PGTo"};